// extracted by mini-css-extract-plugin
module.exports = {"rowInput":"meeting-details_rowInput__326-a","inputItem":"meeting-details_inputItem__3Z3Wf"};